import { InviteEmailFormProps } from './interface'

export function withInviteEmailForm(Component: React.FC<InviteEmailFormProps>) {
  function WithInviteEmailForm(props: InviteEmailFormProps) {
    return <Component {...props} />
  }

  return WithInviteEmailForm
}
